import PreviewModalImage from './PreviewModalImage'
export default PreviewModalImage
